import { Injectable, Injector } from '@angular/core';
import { Logger } from '../log/logger';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../auth/services/auth.service';
export type LogType = 'error' | 'info' | 'warning';
export const Constants = {
	appName: 'InnovaZones',
	PUSH_LOG_URL: window.location.origin + '/pushlog'
}
@Injectable()
export class LogService {
	private logger: Logger;
	private userId: string;
	private authenticatedUser: any;
	private user: any;
	public logFields: {};
	constructor(private injector: Injector) {
		//this.initialize();
	}
	/**
	 * Initialize logger object
	 */
	public initialize() {
		this.logger = new Logger(Constants.appName, Constants.PUSH_LOG_URL);
	}
	/**
	 * Creating log message context
	 */
	public getInfo(requestPath: any = null, exception: any = null, message: string = null) {
		const authService: AuthService = this.injector.get(AuthService);
		this.user = authService.getLoginUserInfo();
		const url = location.href;
		let userDetail: any = '';
		if (this.user) {
			let { id, first_name, last_name, username, email, user_type } = this.user;
			userDetail = { id, first_name, last_name, username, email, user_type };
		}
		this.logFields = {};
		this.logFields['meta'] = {};
		this.logFields['request'] = {};
		this.logFields['exception'] = {};
		this.logFields['navigation'] = {};
		this.logFields['message'] = {};
		this.logFields['meta']['environment'] = 'Production';
		this.logFields['meta']['application'] = Constants.appName;
		this.logFields['request']['current_url'] = url;
		if (exception) {
			this.logFields['exception'] = exception;
		}
		let userName: string = '';
		if (typeof userDetail.first_name != 'undefined') {
			this.logFields['logged_in'] = {};
			this.logFields['logged_in']['user_info'] = userDetail;
			userName = userDetail.first_name + ' ' + userDetail.last_name;
		} else {
			userName = 'User';
		}
		if (message) {
			var message = userName + ' clicked the ' + message + ' button';
			var navMessage = userName + ' visited the route ' + url;
			this.logFields['message']['event_click'] = message;
			this.logFields['message']['event_navigation'] = navMessage;
		}
		if (requestPath) {
			var message = userName + ' visited the route ' + url;
			this.logFields['navigation']['path'] = requestPath;
			this.logFields['navigation']['message'] = message;
		}
		return this.logFields;
	}
	/**
	 * Log the message by their type
	 */
	public logMessage(logType: LogType, errorMessage: any) {
		const logContext = this.getInfo('', errorMessage);
		this.logger.log(logType, logContext);
	}
	/**
	 * Log the router message
	 */
	public logHttpInfo(logType: LogType, requestPath: any) {
		const logContext = this.getInfo(requestPath, '');
		this.logger.log(logType, logContext);
	}
	/**
	 * Log the button clicked message
	 */
	public logClickInfo(logType: LogType, message: any) {
		const logContext = this.getInfo('', '', message);
		this.logger.log(logType, logContext);
	}

}